/** InsCoder WANG.J 2026-08-17 B + Real Eye before-and-after tabs interaction **/

(function () {
  var selector = '[data-cust-real-eye-before-after]';
  var instances = new WeakMap();

  function initialize(root) {
    if (!root || instances.has(root)) {
      return;
    }

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-real-eye-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-real-eye-panel]'));
    var details = Array.prototype.slice.call(root.querySelectorAll('[data-real-eye-details]'));
    var tabsContainer = root.querySelector('.cust-real-eye-before-after__tabs');
    var cleanups = [];
    var activeHoldButton = null;
    var suppressNextTabClick = false;
    var resetTabClickTimer = null;

    function setActiveTab(index, moveFocus) {
      tabs.forEach(function (tab, tabIndex) {
        var isActive = tabIndex === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
      });

      panels.forEach(function (panel, panelIndex) {
        var isActive = panelIndex === index;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
        panel.setAttribute('aria-hidden', String(!isActive));
      });

      details.forEach(function (detail, detailIndex) {
        var isActive = detailIndex === index;
        detail.classList.toggle('is-active', isActive);
        detail.hidden = !isActive;
        detail.setAttribute('aria-hidden', String(!isActive));
      });

      if (moveFocus && tabs[index]) {
        tabs[index].focus();
      }
    }

    function endHold() {
      if (!activeHoldButton) {
        return;
      }

      var panel = activeHoldButton.closest('[data-real-eye-panel]');
      if (panel) {
        panel.classList.remove('is-holding');
      }
      activeHoldButton.setAttribute('aria-pressed', 'false');
      activeHoldButton = null;
    }

    function startHold(event) {
      if (event.type === 'pointerdown' && event.button !== 0) {
        return;
      }

      event.preventDefault();
      endHold();
      activeHoldButton = event.currentTarget;
      var panel = activeHoldButton.closest('[data-real-eye-panel]');
      if (panel) {
        panel.classList.add('is-holding');
      }
      activeHoldButton.setAttribute('aria-pressed', 'true');
    }

    function startKeyboardHold(event) {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }

      event.preventDefault();
      startHold(event);
    }

    tabs.forEach(function (tab, index) {
      var activate = function () {
        if (suppressNextTabClick) {
          suppressNextTabClick = false;
          return;
        }

        setActiveTab(index, false);
      };

      var onKeydown = function (event) {
        var nextIndex = null;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          nextIndex = (index + 1) % tabs.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          nextIndex = (index - 1 + tabs.length) % tabs.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = tabs.length - 1;
        }

        if (nextIndex !== null) {
          event.preventDefault();
          setActiveTab(nextIndex, true);
        }
      };

      tab.addEventListener('click', activate);
      tab.addEventListener('keydown', onKeydown);
      cleanups.push(function () {
        tab.removeEventListener('click', activate);
        tab.removeEventListener('keydown', onKeydown);
      });
    });

    function enableDesktopTabsDrag() {
      if (!tabsContainer) {
        return;
      }

      var desktopQuery = window.matchMedia('(min-width: 990px)');
      var dragPointerId = null;
      var dragStartX = 0;
      var dragStartScrollLeft = 0;

      function endDrag() {
        if (dragPointerId === null) {
          return;
        }

        dragPointerId = null;
      }

      function onPointerDown(event) {
        if (
          !desktopQuery.matches ||
          event.pointerType === 'touch' ||
          event.button !== 0 ||
          tabsContainer.scrollWidth <= tabsContainer.clientWidth
        ) {
          return;
        }

        window.clearTimeout(resetTabClickTimer);
        suppressNextTabClick = false;
        dragPointerId = event.pointerId;
        dragStartX = event.clientX;
        dragStartScrollLeft = tabsContainer.scrollLeft;
      }

      function onPointerMove(event) {
        if (event.pointerId !== dragPointerId) {
          return;
        }

        var distance = event.clientX - dragStartX;
        if (Math.abs(distance) <= 4) {
          return;
        }

        suppressNextTabClick = true;
        tabsContainer.scrollLeft = dragStartScrollLeft - distance;
        event.preventDefault();
      }

      function onPointerEnd(event) {
        if (event.pointerId !== dragPointerId) {
          return;
        }

        endDrag();
        resetTabClickTimer = window.setTimeout(function () {
          suppressNextTabClick = false;
        }, 250);
      }

      tabsContainer.addEventListener('pointerdown', onPointerDown);
      document.addEventListener('pointermove', onPointerMove);
      document.addEventListener('pointerup', onPointerEnd);
      document.addEventListener('pointercancel', onPointerEnd);
      cleanups.push(function () {
        endDrag();
        window.clearTimeout(resetTabClickTimer);
        tabsContainer.removeEventListener('pointerdown', onPointerDown);
        document.removeEventListener('pointermove', onPointerMove);
        document.removeEventListener('pointerup', onPointerEnd);
        document.removeEventListener('pointercancel', onPointerEnd);
      });
    }

    enableDesktopTabsDrag();

    root.querySelectorAll('[data-real-eye-tap-hold]').forEach(function (button) {
      var preventNativeHoldBehavior = function (event) {
        event.preventDefault();
      };

      button.addEventListener('pointerdown', startHold);
      button.addEventListener('keydown', startKeyboardHold);
      button.addEventListener('selectstart', preventNativeHoldBehavior);
      button.addEventListener('contextmenu', preventNativeHoldBehavior);
      cleanups.push(function () {
        button.removeEventListener('pointerdown', startHold);
        button.removeEventListener('keydown', startKeyboardHold);
        button.removeEventListener('selectstart', preventNativeHoldBehavior);
        button.removeEventListener('contextmenu', preventNativeHoldBehavior);
      });
    });

    document.addEventListener('pointerup', endHold);
    document.addEventListener('pointercancel', endHold);
    document.addEventListener('keyup', endHold);
    cleanups.push(function () {
      document.removeEventListener('pointerup', endHold);
      document.removeEventListener('pointercancel', endHold);
      document.removeEventListener('keyup', endHold);
      endHold();
    });

    setActiveTab(Math.max(0, tabs.findIndex(function (tab) { return tab.getAttribute('aria-selected') === 'true'; })), false);
    instances.set(root, function () {
      cleanups.forEach(function (cleanup) {
        cleanup();
      });
    });
  }

  function initializeWithin(scope) {
    if (!scope) {
      return;
    }

    if (scope.matches && scope.matches(selector)) {
      initialize(scope);
    }

    if (scope.querySelectorAll) {
      scope.querySelectorAll(selector).forEach(initialize);
    }
  }

  function initializeAll() {
    document.querySelectorAll(selector).forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeWithin(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector ? event.target.querySelector(selector) : null;
    var cleanup = root && instances.get(root);

    if (cleanup) {
      cleanup();
      instances.delete(root);
    }
  });
})();

/** InsCoder WANG.J 2026-08-17 E + Real Eye before-and-after tabs interaction **/
